import { jsx as _jsx } from "react/jsx-runtime";
import { useNavigate } from "react-router";
import { Text } from "@gravity-ui/uikit";
import GameCard from "@/components/ui/GameCard";
import { PageBlock } from "@/components/ui/PageBlock";
import { RoutesList } from "@/router/routesList";
export var GameList = function (props) {
    var navigate = useNavigate();
    var onDetailsClickHandler = function (gameId) {
        navigate(RoutesList.Game.getGameDetails(gameId));
    };
    return (_jsx(PageBlock, { header: props.header, isCard: !props.list.length, children: props.list.length === 0 ? (_jsx(Text, { children: "\u041D\u0435\u0442 \u0434\u0430\u043D\u043D\u044B\u0445" })) : (props.list.map(function (game) { return (_jsx(GameCard, { game: game, isShort: true, onDetailsClick: onDetailsClickHandler }, game.id)); })) }));
};
